"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronRightSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M7.70710678,3.99810828 L12.998,9.29610828 L13.0025863,9.29294661 L13.7096931,10.0000534 L13.705,10.0031083 L13.708458,10.006707 L13.0013512,10.7138138 L12.998,10.7101083 L7.70710678,16.0002136 L7,15.2931068 L12.291,10.0021083 L7,4.70521506 L7.70710678,3.99810828 Z", fillRule: "evenodd" })));
};
ChevronRightSmall.displayName = 'ChevronRightSmall';
exports.default = ChevronRightSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronRightSmall.js.map